import "./HomePage.css";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import SouthIcon from "@mui/icons-material/South";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import SwiperComponent from "../components/SwiperComponent";
import SwiperComponentBA from "../components/SwiperComponentBA";

const services = [
  "Windshield replacement",
  "Chip & crack repair",
  "Side window replacement",
  "Rear window replacement",
  "Sunroof / moonroof replacement",
  "Custom glass solutions",
];

const highlights = [
  { value: "15+", label: "Years in business" },
  { value: "Family", label: "Owned & operated" },
  { value: "DC · MD · VA", label: "Service area" },
];

function HomePage() {
  /* Support links like /#services coming from other pages */
  useEffect(() => {
    if (window.location.hash) {
      document.querySelector(window.location.hash)?.scrollIntoView();
    }
  }, []);

  return (
    <main>
      <section className="hero">
        <div className="hero-content">
          <span className="eyebrow eyebrow-light">
            Family-owned · DC, Maryland & Virginia
          </span>
          <h1 className="hero-title">
            Auto glass repair & replacement you can count on.
          </h1>
          <p className="hero-subtitle">
            Exceptional service, quality workmanship, and competitive pricing
            for over 15 years.
          </p>
          <div className="hero-actions">
            <Button
              variant="contained"
              size="large"
              component={Link}
              to="/contact"
              className="pill-button"
            >
              Get a Quote
            </Button>
            <Button
              variant="outlined"
              size="large"
              href="#services"
              className="pill-button hero-outline-button"
            >
              Our Services
            </Button>
          </div>
        </div>
        <a className="scroll-cue" href="#about" aria-label="Scroll to About Us">
          <SouthIcon />
        </a>
      </section>

      <div className="highlights">
        {highlights.map((item) => (
          <div className="highlight" key={item.label}>
            <span className="highlight-value">{item.value}</span>
            <span className="highlight-label">{item.label}</span>
          </div>
        ))}
      </div>

      <section id="about" className="section">
        <div className="split">
          <div className="split-text">
            <span className="accent-bar accent-secondary" />
            <h2 className="section-title">About Us</h2>
            <p className="section-text">
              Welcome to U.S. Auto Glass, your trusted family-owned auto glass
              experts for over 15 years serving the DC-Maryland-Virginia area.
              We pride ourselves on delivering{" "}
              <strong>exceptional service</strong>,{" "}
              <strong>quality workmanship</strong>, and{" "}
              <strong>competitive pricing</strong>. Visit us for a reliable,
              friendly service you can count on!
            </p>
          </div>
          <img
            className="split-image"
            src="/modern_van.png"
            alt="U.S. Auto Glass service van"
          />
        </div>
      </section>

      <section id="services" className="section section-alt">
        <div className="split split-reverse">
          <div className="split-text">
            <span className="accent-bar accent-primary" />
            <h2 className="section-title">Our Services</h2>
            <p className="section-text">
              Using top materials and techniques, we make sure your vehicle's
              glass is safe and looks great.
            </p>
            <ul className="service-list">
              {services.map((service) => (
                <li key={service}>
                  <CheckCircleRoundedIcon className="service-icon" />
                  {service}
                </li>
              ))}
            </ul>
          </div>
          <img
            className="split-image"
            src="/Service.png"
            alt="Windshield being replaced"
            loading="lazy"
          />
        </div>
      </section>

      <section id="work" className="section">
        <div className="section-header">
          <span className="accent-bar accent-secondary" />
          <h2 className="section-title">Before & After</h2>
          <p className="section-text">
            From minor repairs to full replacements, see real examples of
            damaged auto glass restored to pristine condition.
          </p>
        </div>
        <SwiperComponentBA />
      </section>

      <section id="reviews" className="section section-alt">
        <div className="section-header">
          <span className="accent-bar accent-primary" />
          <h2 className="section-title">Reviews</h2>
          <p className="section-text">
            We've received many great reviews from our customers over 15 years
            of business. We strive to give the best service possible.
          </p>
        </div>
        <SwiperComponent />
      </section>

      <section className="cta">
        <h2 className="cta-title">Need auto glass repaired or replaced?</h2>
        <p className="cta-text">
          Tell us about your vehicle and the damage, and we'll get back to you
          ASAP.
        </p>
        <Button
          variant="contained"
          size="large"
          component={Link}
          to="/contact"
          className="pill-button cta-button"
        >
          Contact Us
        </Button>
      </section>
    </main>
  );
}

export default HomePage;
